import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { GetOrganizationAccessRequestsResponse } from '../../../../shared/organizationV2';

/**
 * Fetches the access requests for the org that the authenticated user belongs to.
 */
export default function useOrganizationAccessRequests() {
  return useQuery({
    queryKey: ['organizationV2', 'accessRequests'],
    queryFn: () => get<GetOrganizationAccessRequestsResponse>('/api/v2/organization/access-requests'),
  });
}
